import { Api, Codes } from '../api';
import Time from 'utils/time';
import Store from '@/store';
export const keys = {
  学生报名EB1: '学生报名EB1',
  学生报名EB2: '学生报名EB2',
  学生报名RD: '学生报名RD',
  学生apply付费: '学生apply付费',
  学生apply付费截止: '学生apply付费截止',
  志愿者apply付费截止: '志愿者apply付费截止',
  申请实习生截止: '申请实习生截止',
  学生助学金申请: '学生助学金申请',
  志愿者报名EB: '志愿者报名EB',
  志愿者报名RD: '志愿者报名RD',
  峰会补充信息填写: '峰会补充信息填写',
  峰会基本健康信息: '峰会基本健康信息',
  上海会场开放: '上海会场开放',
  杭州会场开放: '杭州会场开放',
  北京会场开放: '北京会场开放',
  申请实习生截止_补录: '申请实习生截止_补录'
};
class DDL {
  constructor() {
    this.ddlKey = 'HSYLC2021-DDL-KEY';
    this.$time = new Time();
  }
  getDDLData = async () => {
    let res = await Store.dispatch('getDDLs');
    let ret = {};
    res.forEach(item => {
      ret[item.key] = item.deadline;
    });
    return ret;
  };
  getDDLItem = async name => {
    let ddls = (await this.getDDLData()) || {};
    return ddls[name];
  };
  isOver = async name => {
    let target = await this.getDDLItem(name);
    if (target) {
      return this.$time.isOverDate(target);
    } else {
      return false;
    }
  };
}
export default new DDL();
